import { useProcurifyIntl } from '@webapp/hooks'
import { LegalEntityForm } from '@webapp/platform/legal-entities/components/LegalEntityForm'
import { type LegalEntity } from '@webapp/platform/legal-entities/entities/LegalEntity'
import messages from './messages'
import { useEditLegalEntityFormPresenter } from './useEditLegalEntityFormPresenter'

export interface IEditLegalEntityFormPresenterProps {
  entity: LegalEntity
  onCancel: () => void
  onSuccess?: () => void
}

export const EditLegalEntityFormPresenter = ({
  entity,
  onCancel,
  onSuccess,
}: IEditLegalEntityFormPresenterProps) => {
  const intl = useProcurifyIntl()
  const {
    state: { initialValues },
    methods: { handleSave, isNameTaken, isExternalIdTaken },
  } = useEditLegalEntityFormPresenter({ entity, onSuccess })

  return (
    <LegalEntityForm
      initialValues={initialValues}
      onContinue={handleSave}
      onCancel={onCancel}
      submitLabel={intl.formatMessage(messages.saveButton)}
      disableCountry
      disableBaseCurrency
      isNameTaken={isNameTaken}
      isExternalIdTaken={isExternalIdTaken}
    />
  )
}

EditLegalEntityFormPresenter.displayName = 'EditLegalEntityFormPresenter'
